import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.625.75h13.5s1.5 0 1.5 1.5v4.5s0 1.5-1.5 1.5h-13.5s-1.5 0-1.5-1.5v-4.5s0-1.5 1.5-1.5"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.125 4.5h-1.5a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h8.25a1.5 1.5 0 0 1 1.5 1.5v1.5m.75 9h-1.5a1.5 1.5 0 0 1-1.5-1.5V16.5a2.25 2.25 0 0 1 2.25-2.25h0a2.25 2.25 0 0 1 2.25 2.25v5.25a1.5 1.5 0 0 1-1.5 1.5m7.5-18.75h2.25"
    }, null, -1)
  ]));
}
const interfaceEditToolPaintRoller = { render };
export {
  interfaceEditToolPaintRoller as default,
  render
};
//# sourceMappingURL=interface-edit-tool-paint-roller.svg.js.map
